/**
 * TrustGrid Page Template
 * Base page wrapper with PageHeader and consistent framework layout
 */

import React from 'react';
import PageHeader from './PageHeader';

/**
 * TrustGridPage Component
 * Complete page wrapper with sidebar, header, and content
 *
 * @param {string} title - Page title
 * @param {string} subtitle - Optional subtitle
 * @param {Array} breadcrumbs - Breadcrumb items [{label, path}]
 * @param {ReactNode} actions - Header action buttons
 * @param {ReactNode} extra - Extra header content
 * @param {ReactNode} children - Page content
 * @param {boolean} fluid - Remove max-width constraint
 * @param {boolean} hideHeader - Hide page header
 * @param {object} containerStyle - PageContainer styles
 * @param {object} headerStyle - PageHeader styles
 */
function TrustGridPage({
  title,
  subtitle,
  breadcrumbs,
  actions,
  extra,
  children,
  fluid = false,
  hideHeader = false,
  containerStyle = {},
  headerStyle = {},
}) {
  return (
    <>
      {!hideHeader && (
        <PageHeader
          title={title}
          subtitle={subtitle}
          breadcrumbs={breadcrumbs}
          actions={actions}
          extra={extra}
          style={headerStyle}
        />
      )}
      {children}
    </>
  );
}

export default TrustGridPage;
